module.exports = __webpack_public_path__ + "1708654020752/assets/img/banner1.ac717002.png";